export const FLOW_US = {
  MOBILE_VERIFICATION: "mobile-verification",
};
export const FLOW_US_TEST = {
  USER: "user",
};
